import { Component, ElementRef, Input, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { FestoSpecial } from '../festo-special';
import { SortAccessorMap, SortState, sortItems } from 'src/app/utils/sort-utils';

type FestoSortKey =
  | 'sku'
  | 'description'
  | 'supplierSku'
  | 'vendorIC'
  | 'orderUnit'
  | 'supplierPrice'
  | 'salesPrice'
  | 'margin'
  | 'deliveryDays'
  | 'creationBy'
  | 'creationDate';

@Component({
  selector: 'app-festo-specials-table',
  templateUrl: './festo-specials-table.component.html',
  styleUrls: ['./festo-specials-table.component.scss'],
})
export class FestoSpecialsTableComponent {
  @ViewChildren('sortIcons') sortIcons!: QueryList<ElementRef>;
  @Input() specials: FestoSpecial[] = [];
  selectedIds = new Set<number>();
  selectedSpecials: FestoSpecial[] = [];

  page: number = 1;
  searchText: string = '';
  sortState: SortState<FestoSortKey> | null = null;
  sortAccessors: SortAccessorMap<FestoSpecial, FestoSortKey> = {
    sku: special => special.sku,
    description: special => special.description,
    supplierSku: special => special.supplierSKU,
    vendorIC: special => special.vendorIC1,
    orderUnit: special => special.orderUnit,
    supplierPrice: special => special.supplierPrice,
    salesPrice: special => special.salesPrice,
    margin: special => special.margin,
    deliveryDays: special => special.deliveryDays,
    creationBy: special => special.creationBy,
    creationDate: special => special.creationDate,
  };

  constructor(private renderer: Renderer2) {}

  isSelected(s: FestoSpecial): boolean {
    return this.selectedIds.has(s.id);
  }

  toggleSelection(special: FestoSpecial, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.selectedIds.add(special.id);
      this.selectedSpecials.push(special);
    } else {
      this.selectedIds.delete(special.id);
      this.selectedSpecials = this.selectedSpecials.filter(s => s.id !== special.id);
    }
  }

  getNextAscending(field: FestoSortKey): boolean {
    if (!this.sortState || this.sortState.key !== field) {
      return true;
    }

    return !this.sortState.ascending;
  }

  sortByField(field: FestoSortKey, ascendingOrder: boolean = this.getNextAscending(field)) {
    this.sortState = { key: field, ascending: ascendingOrder };
    this.specials = sortItems(this.specials, field, ascendingOrder, this.sortAccessors);
    this.updateSortingHighlight(`${field}${ascendingOrder ? 'Asc' : 'Desc'}`);
  }

  updateSortingHighlight(highlightElement: string) {
    this.sortIcons.forEach((element: ElementRef) => {
      const nativeElement = element.nativeElement as HTMLElement;
      if (nativeElement.id == highlightElement) {
        this.renderer.addClass(nativeElement, 'highlight');
      } else {
        this.renderer.removeClass(nativeElement, 'highlight');
      }
    });
  }

  onSearchTextChange() {
    this.page = 1;
  }
}
